import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Observable, of, tap } from 'rxjs';
import { CountUpMoneyDirective } from '../../../../shared/general/directives/count-up-money.directive';
import { GtmService } from '../../../../core/services/gtm.service';

@Component({
  selector: 'app-commission-calculator',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    FormsModule,
    MatFormFieldModule,
    MatFormField,
    MatLabel,
    MatInputModule,
    MatIconModule,
    CountUpMoneyDirective
  ],
  templateUrl: './commission-calculator.html',
  styleUrl: './commission-calculator.scss',
})
export class CommissionCalculator implements OnInit {
  private gtm = inject(GtmService);
  private readonly dialogRef = inject(MatDialogRef<CommissionCalculator>);
  listings = 0;
  referrals = 0;
  calculatedTotal = 0;
  constructor() {}

  ngOnInit(): void {
    this.gtm.pageView({
      page_path: '/sales/calculator',
      page_title: 'Horizinns | Commission Calculator' 
    });
  }

  onSubmit() {
    this.calcListings().pipe(tap((result) => {
      this.calculatedTotal = result ?? 0;
      console.log(result, this.calculatedTotal);
    })).subscribe();
  }

  @Output() cancel = new EventEmitter<void>();
  
  onCancel(): void {
    this.cancel.emit();
    this.dialogRef.close();
  }
  onClear() {
    this.listings = 0;
    this.referrals = 0;
    this.calculatedTotal = 0;
  }

  onValueChange() {
    // We no longer need the pipe/subscribe overhead if it's local logic
    // but keeping your structure:
    this.calcListings().subscribe(result => {
      this.calculatedTotal = result ?? 0;
    });
  }
  
  calcListings = (): Observable<any> => {
    let sum = 0;
    const listCost = 300;
    const totalListings = (this.listings != undefined && this.listings > 0) ? (this.listings) : 0;
    const totalReferrals = (this.referrals != undefined && this.referrals > 0) ? this.referrals : 0;
    console.log('totalListings', totalListings);
    console.log('totalReferrals', totalReferrals);
    // if (totalListings == 1) {
    //   sum = (listCost * 0.3);
    // } else {
    const counter: number[] = [0, 0, 0, 0, 0];
    
    for (let i = 1; i <= totalListings; i++) {
      if (i <= 10) {
        console.log(listCost * 0.3);
        counter[0] += 1;
        sum += (listCost * 0.3);
      } else if (i <= 25) {
        console.log(listCost * 0.4);
        counter[1] += 1;
        sum += (listCost * 0.4);
      } else if (i <= 75) {
        console.log(listCost * 0.5);
        counter[2] += 1;
        sum += (listCost * 0.5);
      } else if (i <= 250) {
        console.log(listCost * 0.6);
        counter[3] += 1;
        sum += (listCost * 0.6);
      } else if (i > 250) {
        console.log(listCost * 0.7);
        counter[4] += 1;
        sum += (listCost * 0.7);
      }
    }

    console.log('listings total ', sum, counter);
    
      // bonus
      console.log('bonus total', (totalListings > 250) ? (sum * 0.1) : 0);
      if (totalListings > 250) {
        sum += (sum * 0.1);
      }
      console.log('sum after bonus', sum);

    // referral rate
    console.log('referral total', totalReferrals * (listCost * 0.1));
    sum += totalReferrals * (listCost * 0.1);

    console.log('total estimated commission', sum);
    return of(sum);
  };
}
